var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternalTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.351 10.538L11.451 0.638C11.055 0.242 10.505 0 9.9 0H2.2C0.99 0 0 0.99 0 2.2V9.9C0 10.505 0.242 11.055 0.649 11.462L10.549 21.362C10.945 21.758 11.495 22 12.1 22C12.705 22 13.255 21.758 13.651 21.351L21.351 13.651C21.758 13.255 22 12.705 22 12.1C22 11.495 21.747 10.934 21.351 10.538ZM12.1 19.811L2.2 9.9V2.2H9.9V2.189L19.8 12.089L12.1 19.811Z",
    fill: "#007AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95078 6.6C5.86205 6.6 6.60078 5.86127 6.60078 4.95C6.60078 4.03873 5.86205 3.3 4.95078 3.3C4.03951 3.3 3.30078 4.03873 3.30078 4.95C3.30078 5.86127 4.03951 6.6 4.95078 6.6Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalTags);
export default __webpack_public_path__ + "static/media/internal_tags.70e083fb.svg";
export { ForwardRef as ReactComponent };